import styles from "../styles/theme";
import { Link } from "react-router-dom";

export default function Footer() {
  const linkStyle = { color: "#7a7570", fontSize: 13, textDecoration: "none" };
  return (
    <footer style={styles.footer}>
      <div style={styles.footerInner} data-footer-inner>
        <span style={styles.logoText}>UXO<span style={styles.logoAccent}>hire</span></span>
        <span style={styles.footerSub}>The specialized job board for the UXO industry.</span>
        <span style={{ marginLeft: "auto", display: "flex", gap: 16 }}>
          <Link to="/terms" style={linkStyle}>Terms of Service</Link>
          <Link to="/privacy" style={linkStyle}>Privacy Policy</Link>
          <Link to="/support" style={linkStyle}>Support</Link>
        </span>
      </div>
    </footer>
  );
}
